import { Component } from 'react';

export default class BaseComponent<P, S> extends Component<P, S> {
  promisedSetState<K extends keyof S>(
    state:
      | ((prevState: Readonly<S>, props: Readonly<P>) => Pick<S, K> | S | null)
      | Pick<S, K>
      | S
      | null,
    callback?: () => void,
  ) {
    return new Promise((resolve) => {
      // @ts-ignore
      super.setState(state, resolve);
    });
  }
}
